import React, { Component } from 'react';
import { View, Text } from 'react-native';
import utils from '../utils';
import { enabledStyle, disabledStyle } from '../commonStyles';

const statusMap: { [propName: string]: string } = {
    10: 'isWarning',
    11: 'isWarning'
};

const appActionMap = {
    pay: true
};

class Bnb extends Component<{
    data: {
        productTitle: string;
        fromDate: string;
        toDate: string;
        roomCount: number;
        nightCount: number;
        _disable: boolean;
    };
}> {
    public static formatData(data: any) {
        const newData = { ...data };
        // 订单状态
        newData._orderStatus = statusMap[newData.status];
        // 按钮
        newData.actionInfos = utils.buildActionInfos(newData.appAction, appActionMap);
        // icon
        newData.iconfont = '\uf34d';
        newData.iconColor = '#ef5e60';
        // 价格
        newData.fixPrice = utils.fixPrice(newData.price);
        return newData;
    }

    public render() {
        const {
            data: {
                productTitle = '',
                fromDate = '',
                toDate = '',
                roomCount = 0,
                nightCount = 0,
                _disable = false
            } = {}
        } = this.props;
        const styles = _disable ? disabledStyle : enabledStyle;

        return (
            <View style={styles.left}>
                <Text numberOfLines={2} style={styles.newOrderTitle}>
                    {productTitle}
                </Text>
                {Boolean(fromDate && toDate) && (
                    <Text numberOfLines={1} style={styles.newOrderSubTitle}>
                        {`${fromDate} 至 ${toDate}`}
                    </Text>
                )}
                {Boolean(nightCount || roomCount) && (
                    <Text numberOfLines={1} style={styles.newOrderSubTitle}>
                        {nightCount ? `${nightCount}晚 ` : ''}
                        {roomCount ? `${roomCount}间` : ''}
                    </Text>
                )}
            </View>
        );
    }
}

export default Bnb;
